export default __webpack_public_path__ + "static/media/add-icon.21886bcc.svg";